import createClient, { Middleware, ClientOptions, Client } from 'openapi-fetch';
import { paths } from './types';
import { API_BASE_URL } from './constants';

type AuthMiddlewareProps = {
  authToken?: string | null;
};

const auth = ({ authToken }: AuthMiddlewareProps): Middleware => ({
  onRequest: ({ request }) => {
    if (authToken) {
      request.headers.set('Authorization', `Bearer ${authToken}`);
    }
    // set "foo" header
    return request;
  },
});

export type ApiClientConfig = ClientOptions & {
  authToken: AuthMiddlewareProps['authToken'];
};

export type ApiClient = Client<paths> & {
  authToken: string | null;
};

export const ApiClient = {
  from: ({
    authToken,
    baseUrl = API_BASE_URL,
    ...others
  }: Partial<ApiClientConfig> = {}): ApiClient => {
    const client = createClient<paths>({
      baseUrl,
      ...others,
    }) as ApiClient;

    client.use(auth({ authToken }));
    client.authToken = authToken || null;

    return client;
  },
};
